import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Box sx={{ display: "flex", justifyItems: "center" }}>
      <Typography
        variant="h6"
        noWrap
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
        }}
      >
        <img src="/logo.png" height={20} width={20} alt="لوگو" />
        <Link to="https://portfoyar.com/">
          <Typography sx={{ fontWeight: 900, fontSize: "20px" }}>
            پـرتـفـویـار
          </Typography>
        </Link>
      </Typography>
    </Box>
  );
};

export default Logo;
